module.exports = __webpack_public_path__ + "img/Advanz Pharma Logo.2bca776c.png";